<template>
  <main-layout>
    <template slot="header-title">
      {{ $t('banner.title') }}
    </template>
    <template slot="header-actions">
      <common-button
        @click="isOpenFormNewBanner = true">Create a banner</common-button>
    </template>
    <template slot="main">

      <banners-ui-list />

      <banners-ui-modal-create
        v-if="isOpenFormNewBanner"
        :open="isOpenFormNewBanner"
        :site="site"
        @banner-created="(banner) => $router.push({name: 'BannerEdit', params: {id: banner.id}})"
        @close="isOpenFormNewBanner = false" />

    </template>
  </main-layout>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Banner',
  data () {
    return {
      isOpenFormNewBanner: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },
  methods: {
    ...mapActions('banners', ['addBanner'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Banner/BannerList.vue